import angular from 'angular';

class ComboQuestionService {

  formatDisplayedExpression (answers, expression) {
    const valueMapping = {};
    answers.forEach((answer) => {
      valueMapping[answer.id] = answer.text;
    });
    const expressionToDisplay = expression.replace(/(!?\d+)(\w*)/g, (match) => {
      let value = valueMapping[match];
      return `${value}`;
    });
    return expressionToDisplay;
  }

  formatMappingAnswers (answers) {
    const checkedValuesExpression = [];
    const checkedValuesText = []
    answers.forEach(function(answer) {
      if (answer.checked) {
        checkedValuesExpression.push(answer.id);
        checkedValuesText.push(answer.text);
      }
    });
    return {
      expressionIds: `(${checkedValuesExpression.join(' and ')})`,
      expressionText: checkedValuesText.join(' and ')
    }
  }

  clearSelected(answers) {
    answers.forEach(function(answer) {
      answer.checked = false
    });
    return answers
  }

  updateInOperand(option, operand) {
    option.inOperand = operand
  }


  updateOutOperand(option, operand) {
    option.outOperand = operand
  }


  addAnswerSection(mainOption, selectedOption, condition = null) {
    const newOptionNum = 'option' + (Math.random() + 100 + mainOption.length + 1)
    const newOption = {option: {
        name: newOptionNum,
        selectedOption,
        inOperand: null,
        condition
      } };
    mainOption.push((newOption));
  }

}

angular.module('pims').service('ComboQuestionService', ComboQuestionService);
